module.exports = __webpack_public_path__ + "img/unimed_numeros.06e6fb61.svg";